//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"DistanceToRoadGeneral",0,"Expression",0],[1,"DistanceToRoadUnderAxle",0,"Expression",0],[0,"ExtendSurface",1,0],[1,"ExtensionFactor",0,"Expression",0],[1,"FrontUnderAxleFace",0,"ScCollector",0],[1,"GeneralClearanceFace",0,"ScCollector",0],[0,"Loading",1,0],[0,"Position",1,0],[1,"RearUnderAxleFace",0,"ScCollector",0],[0,"RequirementsControl",1,0],[0,"SectionCurve",1,0],[0,"ShowDistanceMeasurement",1,0],[0,"Standard",1,0],[0,"SurfaceLength",1,0],[0,"UseGeneralSurface",1,0],[0,"UseUnderAxleSurface",1,0],[0,"Visualization",1,0],[0,"WheelSize",1,0]],[],[]];
SPLM.Features.VehicleDesign.GroundClearanceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.GroundClearanceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.GroundClearanceBuilder.RequirementControls = Object.freeze({
    "StandardDriven" : "StandardDriven", "UserDefined" : "UserDefined"});

SPLM.Features.VehicleDesign.GroundClearanceBuilder.WheelType = Object.freeze({
    "StaticRadius" : "StaticRadius", "Diameter" : "Diameter"});

SPLM.Features.VehicleDesign.GroundClearanceBuilder.SurfaceLengthType = Object.freeze({
    "FrontToRear" : "FrontToRear", "FullVehicle" : "FullVehicle"});

SPLM.Features.VehicleDesign.GroundClearanceBuilder.PositionType = Object.freeze({
    "Front" : "Front", "Rear" : "Rear", "Both" : "Both"});

SPLM.Features.VehicleDesign.GroundClearanceBuilder.SectionCurveType = Object.freeze({
    "HorizontalLine" : "HorizontalLine", "CircularArc" : "CircularArc"});

SPLM.Features.VehicleDesign.GroundClearanceBuilder.VisualizationTypes = Object.freeze({
    "Curve" : "Curve", "Surface" : "Surface", "CurveandSurface" : "CurveandSurface"});

export default SPLM;